/**
 * Authentication feature configuration and constants
 */
export const AUTH_CONFIG = {
  REGISTRATION_ENABLED: true,
  EMAIL_REDIRECT_PATH: '/verify-email'
}
